/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// Scroll-reveal sticky header — animates `top` (not transform) to keep sticky working
(function () {
  function initScrollRevealHeader() {
    var scrollHeader = document.querySelector('.shopify-section-header');
    if (!scrollHeader || !document.querySelector('.js-header-scroll')) return;

    var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var isHidden = false;
    var animFrame = null;
    var currentTop = -1; // tracks the live animated top value (px)
    var delta = 5;

    function headerHeight() { return scrollHeader.offsetHeight; }
    function threshold() { return headerHeight() + 50; }
    function hiddenTop() { return -(headerHeight() + 10); }

    function easeInOut(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }

    function animateTo(targetY, duration, onDone) {
      if (animFrame) { cancelAnimationFrame(animFrame); animFrame = null; }
      var startY = currentTop;
      var startTime = null;

      function tick(ts) {
        if (!startTime) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        currentTop = startY + (targetY - startY) * easeInOut(progress);
        scrollHeader.style.top = currentTop + 'px';
        if (progress < 1) {
          animFrame = requestAnimationFrame(tick);
        } else {
          currentTop = targetY;
          animFrame = null;
          if (onDone) onDone();
        }
      }
      animFrame = requestAnimationFrame(tick);
    }

    function hide() {
      if (isHidden) return;
      isHidden = true;
      document.body.classList.remove('header-down');
      document.body.classList.add('header-up');
      animateTo(hiddenTop(), 300, null);
    }

    function show() {
      if (!isHidden) return;
      isHidden = false;
      document.body.classList.remove('header-up');
      document.body.classList.add('header-down');
      animateTo(-1, 300, function () {
        scrollHeader.style.top = ''; // hand back to CSS
        currentTop = -1;
      });
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var st = window.pageYOffset || document.documentElement.scrollTop;

        if (st <= threshold()) {
          if (isHidden) show();
        } else if (Math.abs(st - lastScrollTop) > delta) {
          if (st > lastScrollTop) { hide(); } else { show(); }
        }

        lastScrollTop = st;
        ticking = false;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollRevealHeader);
  } else {
    initScrollRevealHeader();
  }
}());

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}